import React from 'react'
import './Header.css'
import 'font-awesome/css/font-awesome.min.css';


let lpKey = 'lushplans-user-key_couples'
class Header extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      user: localStorage.getItem(lpKey)
    }
    console.log(typeof this.state.user)
  }

  componentDidMount () {

  }

  logOut () {
    localStorage.removeItem(lpKey)
  }

  render () {
    return (
      <div className='fixedHeaderContainer'>
        <div className='headerWrapper wrapper'>
          <header>
            <a href='/'><img className='logo' src='https://lushplans.com/img/logo_color.png' alt='Lush Plans' />
              <h2 className='headerTitleWithLogo'>Lush Plans</h2></a>
            <div className='navigationWrapper navigationSlider'>
              <nav className='slidingNav'>
                <ul className='nav-site nav-site-internal'>
                  <li className=''><a href='./#guests' target='_self'>Guests</a></li>
                  <li className=''><a href='./#wedding' target='_self'>Details</a></li>  
                  <li className=''><a id='vendor-cta' href='./#builder'>Customize wedding package</a></li>
                  <li className=''><a><i className="fa fa-user fa-profile"> </i></a></li> 
                </ul>
              </nav>
            </div>
          </header>
        </div>
      </div>
    )
  }
};

export default Header



// WEBPACK FOOTER //
// ./src/Header/Header.js